// src/pages/MyConversations.tsx — read-only conversation surface.
// The full message thread (messages[]) is a server-only field and is never
// returned to the client, so this view surfaces engine status only. A sanitized
// thread-read endpoint is downstream; engine writes are out of scope here.
import { useChatStatus } from "@/lib/queries";
import { Card, PageHeader, Spinner, EmptyState } from "@/components/ui";

export function MyConversations() {
  const { data, isLoading } = useChatStatus();

  return (
    <div className="space-y-6">
      <PageHeader
        title="My Conversations"
        subtitle="Your specialist intake thread (read-only)."
      />

      {isLoading ? (
        <Spinner />
      ) : !data ? (
        <EmptyState
          title="No conversation yet"
          hint="Start an intake conversation in a consumer app to populate your specialist thread."
        />
      ) : (
        <Card>
          <h2 className="mb-2 text-sm font-medium text-ls-fg">Intake status</h2>
          <dl className="grid grid-cols-2 gap-y-2 text-sm">
            {Object.entries(data).map(([k, v]) => (
              <div key={k} className="contents">
                <dt className="text-ls-muted">{k}</dt>
                <dd className="text-ls-fg">{String(v)}</dd>
              </div>
            ))}
          </dl>
          <p className="mt-4 text-xs text-ls-muted">
            The full message thread is server-only and not rendered here. A
            sanitized read endpoint is planned.
          </p>
        </Card>
      )}
    </div>
  );
}
